export const AgentCommissionTrackingPermissions = {
  ViewAgentCommissionTracking :  {
    components: null ,  
    componentsId: null , 
    permissionsId: 'bc76ccf5-c3ad-4f81-99b3-3da134a4c313' , 
    permissionsName: 'View Agent commission tracking'  ,  
  }
};
